<template>
  <div class="jgcc">
    <ul class="tab-box">
      <li class="tab" :class="{active: jgTabIdx == 1}" @click="tabJg(1)">在持</li>
      <li class="tab" :class="{active: jgTabIdx == 2}" @click="tabJg(2)">历史持仓</li>
      <li class="tab select-type" @click="all">
        <div>{{currencyText}}</div>
        <img class="icon" src="@/assets/down.png" alt="">
        <ul class="select-ul" v-show="isSelect">
          <li class="select-li" v-for="(item,index) in bzData" :key="index" @click.stop="select(item.name)">{{item.name}}</li>                   
        </ul>
      </li>
    </ul>
    <div class="scroll"  @scroll="listenScroll">
      <ul class="jgcc-ul-box">
        <li class="list" v-for="(item,index) in orderData" :key="index">
            <div class="list-head">                        
                <div class="type">{{item.currency_name}}</div>                        
                <div class="status">{{item.open_time}}</div>
            </div>
            <div class="list-body">
                <div class="list-item">
                    <div>{{$t('jgcc.fx')}}</div>
                    <div class="t1" :class="{red: item.type == 2}">{{item.type | fx}}</div>                           
                </div>
                <div class="list-item">
                    <div>{{$t('jgcc.sl')}}</div>
                    <div class="t2">{{item.amount}}</div>                           
                </div>
                <div class="list-item">
                    <div>{{$t('jgcc.jgsj')}}</div>
                    <div class="t2">{{item.cut_time}}s</div>                           
                </div>
                <div class="list-item" v-show="status == 2">
                    <div>{{$t('jgcc.gmj')}}</div>
                    <div class="t2">{{item.price}}</div>                           
                </div>
                <div class="list-item" v-show="status == 2">
                    <div>{{$t('jgcc.jsj')}}</div>
                    <div class="t2">{{item.close_price}}</div>                           
                </div>
                <div class="list-item">
                    <div>{{$t('jgcc.yk')}}</div>
                    <div class="t1" :class="{red: item.profit_loss < 0}" >{{item.profit_loss}}</div>                           
                </div>
            </div>
            <div class="list-foot" v-show="tabIdx ==1 ">
                <div class="btn" @click="detail(item.id,item.currency_name,item.type,1)">{{$t('jgcc.xq')}}</div>
                <div class="date">{{item.close_time_set_stamp | times}}</div>
            </div>            
        </li>
      </ul>
    </div>       
  </div>
</template>

<script>
import { getmarketList,cutOrderList,cutOrder } from "@/api/asset";
let that
export default {
  data() {
    return {
      jgTabIdx: 1,
      isSelect: false,
      currencyText: '全部类型',
      currency: '',
      isNoData: false,
      isGoTOP: false, 
      isShow: false,
      isMask: false,                       
      bzData: [],
      tabIdx: 1,     
      timeIdx: 0,              
      status: 1,//1.在持，2.历史
      type: 1,//1买涨，2买跌 
      symbol: '',
      orderId: '',   
      cutTimeList: [],                
      orderData: [], 
      detailData: {},
      timeObj: {}, 
      curDataLength: 10,
      tzmoney: '',//投资金额
      newprice: '0.0000',
      xianjia: '',//现价
      fx: this.$t('jgcc.fx'),
      fxText: '',//方向文本                   
      rate: '',//手续费
      useBalance: 0.0000,//可以余额
      orderId: '',
      timer: null,
      timerTimes: null,
      timerOrder: null,
      is_close: false,
      isJgShow: false,  
      isJgTime: false,//交割倒计时
      isScroll: false,//是否滚动到底部
      close_time_set_stamp: '',
      page: 1,
      limit: 10
    };
  },  
  beforeCreate(){
    that = this;
  },
  mounted(){
    this.getmarketList();
    this.getOrderList();    
  },
  methods: {
    tabJg(idx){
      this.jgTabIdx = idx;
      this.status = idx;
      this.page = 1;
      this.orderData = [];      
      this.getOrderList();
    },
    all(){
      this.isSelect = true;
    },
    select(text){
      this.page = 1;
      this.orderData = [];  
      this.currency = this.currencyText =  text;
      this.isSelect = false;
      this.getOrderList();
    },
    getmarketList(){
      var params = {
        id: 1
      }
      getmarketList(params).then((res) => {        
        this.bzData = res;
      }); 
    },   
    getOrderList(){         
        let params = {
            status: this.status,                                             
            currency: this.currency,                       
            limit: this.limit,  
            page: this.page,              
        }
        cutOrderList(params).then((res) => {                 
          if(res.list.length > 0){   
              if(this.isScroll){
                  this.orderData = this.orderData.concat(res.list);
              }else{
                  this.orderData = res.list;      
              }
              this.curDataLength = res.list.length;     
                                                                                            
          }else{
              this.curDataLength = res.list.length;                            
          }
          if(this.orderData.length > 0){
              this.isNoData = false;
          }else{
              this.isNoData = true;                            
          }                        
          this.setIntervalTime();// 调取倒计时
        });        
    },
    detail(id,symbol,type,isDetail){
        this.isMask = true;
        this.isJgTime = true;
        this.is_close = false;
        this.orderId = id;
        this.symbol = symbol;
        if(type == 1){
            this.fxText = this.$t('jgcc.mz');
        }else{
            this.fxText = this.$t('jgcc.md');
        }
        $('#times').html('');
        clearInterval(this.timerTimes);
        document.getElementById("circle").style.strokeDashoffset = 0; 
        this.getOrderDetail(isDetail);
        this.daymarket(); 
        
    },
    getOrderDetail(isDetail){
       let that = this;
        $('#times').html('');
        cutOrder({id:that.orderId}).then((res) => {
          that.detailData = res; 
          if(isDetail == 1){
              that.endTimes(res.close_time_set)
          }else{
              that.downTimes(res.cut_time)
          }     
        });         
    },   
    setIntervalTime(){                                    
        setInterval(() => {
            this.timer = this.orderData.forEach(item => {
                item.close_time_set_stamp = this.countTime(item.close_time_set)
            })
        },1000)                    
    },   
    countTime(end){                        
        var nowtime = new Date().getTime(); // 当前时间 毫秒数
        var endTime = Date.parse(new Date(end.replace(/-/g, "/"))); //结束时间  毫秒数
        var totalSeconds = (endTime - nowtime) / 1000; // 结束时间-当前时间 = 剩余多少时间
        var day = parseInt(totalSeconds / 3600 / 24); //天
        var hour = parseInt((totalSeconds / 3600) % 24); //时
        var minute = parseInt((totalSeconds / 60) % 60); //分
        var second = parseInt(totalSeconds % 60); //秒 
        hour = this.addZero(hour);
        minute = this.addZero(minute);
        second = this.addZero(second);
        var residueTime = hour + this.$t('jgcc.shi') + " " + minute + this.$t('jgcc.fen') + " " + second + this.$t('jgcc.miao');                      
        if (totalSeconds < 0) {
            return residueTime = ' ';                                                 
        }else{
            return residueTime 
        }                   
    }, 
    // 补齐格式不满10加0
    addZero (n) {
        return n < 10 ? '0' + n : n
    },   
    listenScroll(e) {  //监听滚动
      let ele = e.srcElement ? e.srcElement : e.target; 
      clearInterval(this.timerOrder);                       
      if(ele.scrollTop > 200){
          this.isGoTOP = true
      }else{
          this.isGoTOP = false
      }					
      if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
        if(this.curDataLength >= this.limit){                                 
          this.isScroll = true;                               
          this.page ++;
          this.getOrderList();
        }else{
            this.isScroll = false
        }							
      }
    },
    buy(obj,fx){
        this.timeIdx = 0;
        this.isJgShow = true;
        this.fxText = obj;  
        this.fx = fx;         
        this.getCutTimeList();
        this.getAsset();
    },
    agin(){
        this.isMask = true;
        this.isJgTime = false;
        this.isJgShow = true;
        this.is_close = false;                      
        this.getCutTimeList();   
        this.getAsset(); 
        clearInterval(this.timerTimes);
        $('#times').html('');   
        document.getElementById("circle").style.strokeDashoffset = 0; 
    },
    close(){
        this.isJgShow = false;
        this.isJgTime = false;
        this.isMask = false;
        this.is_close = false;
        clearInterval(this.timerTimes);
        $('#times').html('');
        document.getElementById("circle").style.strokeDashoffset = 0;  
    },  
  },
  filters:{
      fx(val){                    
          if(val == 1){
              return that.$t('jgcc.mz')
          }else if(val == 2){
              return that.$t('jgcc.md')
          }else{
              return that.$t('jgcc.mz')
          }                    
      },
      toFixed4: function (value, options) {
          value = Number(value);
          return value.toFixed(4);
      },
      times: function (value, options) {  
          if(value){
              if(value.indexOf(that.miao) > 0){
                  return value
              }else{
                  return ''
              }
          }else{
              return ''
          }                    
      },                        
  },
  beforeDestroy () {
      clearInterval(this.timer);
      clearInterval(this.timerTimes);
      clearInterval(this.timerOrder);         
  },
};
</script>

<style lang="scss">
  .jgcc .tab-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    color: #637085;
    font-size: 12px;
  }
  .jgcc .tab-box .tab{
    padding-bottom: 5px;
    border-bottom: transparent;
    cursor: pointer;
  }
  .jgcc .tab-box .active{
    color: #7a98f7;
    border-bottom: 1px solid #7a98f7;
  }
  .select-type{
    position: relative;
    display: flex;
    align-items: center;
  }
  .select-type .icon{
    width: 12px;
    margin: 0 5px;
  }
  .select-type .select-ul{
    position: absolute;
    right: 0;
    top: 26px;
    width: 120px;
    background: #fff;
  }
  .select-type .select-ul .select-li{
    width: 100%;
    height: 30px;
    color: #000;
    line-height: 30px;
    font-size: 12px;
    border-bottom: 1px solid #ccc;
    text-align: center;
  }
  .scroll{
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    height: auto;
    overflow-y: scroll;
  }
  .jgcc-ul-box .list{
    margin-top: 6px;
    padding: 14px;
    background: #141d2d;
}
.jgcc-ul-box .list .list-head{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 10px;
	border-bottom: 1px solid #e0e0e0;
}
.jgcc-ul-box .list .buy{
    padding: 2px 4px;
    color: #fff;
    font-size: 12px;
    border-radius: 6px;
    background: #00c483;
}
.jgcc-ul-box .list .sell{
    background: #d85656;
}
.jgcc-ul-box .list .type{    
    padding: 0 10px 0 0;
    color: #fff;
    font-weight: bold;
}
.jgcc-ul-box .list .type span{
    color: #b5b5b5;
    font-size: 13px;
    font-weight: normal;
}
 .jgcc-ul-box .list .date{
    color: #b5b5b5;
}
.jgcc-ul-box .list .time{
    flex: 1;
    padding-left: 10px;
    color: #b5b5b5;
}
.jgcc-ul-box .list .btn-cancle{
    padding: 4px 8px;
	color: #218adc;
	font-size: 12px;
    border: 1px solid #218adc;
    border-radius: 4px;
}
.jgcc-ul-box .list .status{
    color: #aaa;
}
.jgcc-ul-box .list .list-body{
	padding-bottom: 12px;
	border-bottom: 1px solid #e0e0e0;
}
.jgcc-ul-box .list .list-body .list-item{
	display: flex;
	justify-content: space-between;
    align-items: center;
    margin-top: 12px;
	color: #aaa;
	font-size: 13px;
}
.jgcc-ul-box .list .list-body .list-item .t1{
	color: #00c483;
}
.jgcc-ul-box .list .list-body .list-item .t2{
	color: #aaa;
}
.jgcc-ul-box .list .list-body .list-item .t3{
	color: #db4949;
}
.jgcc-ul-box .list .list-foot{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-top: 14px;
	font-size: 13px;
}
.jgcc-ul-box .list .list-foot .btn{
	width: 85px;
	height: 25px;
	color: #fff;	
	line-height: 25px;
	border-radius: 4px;
	background: #218adc;
	text-align: center;
}
.jgcc-ul-box .list .list-foot .date{
	color: #218adc;
}
.jgcc-ul-box .list .list-foot.history{
	justify-content: center;
}
.jgcc-ul-box .list .list-foot.history .date{
	color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/jgcc.vue